import styled from 'styled-components';
import { colors } from '../../constants';

export const SubTitle = styled.h4`
    font-size: 15px;
    font-weight: 300;
    color: ${colors.greyMedium};
    margin: 6px 0 32px;
    line-height: 1.5;
`;
